// extracted by mini-css-extract-plugin
export default {"sections":"ServiceView_sections__1p59L","description":"ServiceView_description__wnzTh","file":"ServiceView_file__cgcbc","one-file":"ServiceView_one-file__M42qk"};